<div class="model-edit-container">
  @if (isLoading) {
    <div class="loading-container">
      <p-progressSpinner styleClass="loading-spinner"></p-progressSpinner>
      <p i18n="@@adminModels.loading">Загрузка моделей...</p>
    </div>
  } @else {
    <div class="filters-row">
      <div class="filter-field">
        <label for="filterType" class="field-label" i18n="@@adminModels.type">Тип</label>
        <p-select
          inputId="filterType"
          [options]="modelTypeOptions"
          [(ngModel)]="selectedModelType"
          (ngModelChange)="onFilterChange()"
          optionLabel="label"
          optionValue="value"
          i18n-placeholder="@@adminModels.allTypes"
          placeholder="Все типы"
          [showClear]="true"
          styleClass="w-full">
        </p-select>
      </div>

      <div class="filter-field">
        <label for="filterGateway" class="field-label" i18n="@@adminModels.gateway">Шлюз</label>
        <p-select
          inputId="filterGateway"
          [options]="gatewayOptions"
          [(ngModel)]="selectedGatewayCode"
          (ngModelChange)="onFilterChange()"
          optionLabel="label"
          optionValue="value"
          i18n-placeholder="@@adminModels.allGateways"
          placeholder="Все шлюзы"
          [showClear]="true"
          styleClass="w-full">
        </p-select>
      </div>

      <div class="filter-action">
        <p-button
          i18n-label="@@adminModels.sync"
          label="Синхронизировать"
          icon="pi pi-sync"
          [loading]="isSyncing"
          [disabled]="!selectedModelType || !selectedGatewayCode"
          (click)="syncSelected()">
        </p-button>
      </div>
    </div>

    <div class="selector-section">
      <app-model-selector
        [modelsHierarchy]="filteredHierarchy"
        [modelTypes]="modelTypesFilter"
        [allowSelectFromTester]="false"
        [showPropertiesEdit]="true"
        [includeAll]="modelsIncludeAll"
        (includeAllChange)="onModelsIncludeAllChange($event)">
      </app-model-selector>
    </div>
  }
</div>
